<template>
  <a-modal
    :visible="modalVisible"
    class="modal-main"
    :footer="null"
    :maskClosable="false"
    @cancel="handleCloseModal"
  >
    <h1 class="modal-title">Contact sales</h1>
    <p class="hint">Fill out the form and we'll be in touch</p>

    <a-form layout="vertical" :model="formList" :rules="rules" ref="formList">
      <a-form-item name="country">
        <LineSelect
          v-model:value="formList.country"
          :selectList="countriesList"
          labelName="nameEn"
          valueName="nameEn"
          placeholder="Counrty"
          :show-search="true"
          :filterOption="filterOption"
        ></LineSelect>
      </a-form-item>

      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-item name="firstName">
            <LineInput
              class="input-item"
              v-model:value="formList.firstName"
              placeholder="First Name"
            ></LineInput>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item name="lastName">
            <LineInput
              class="input-item"
              v-model:value="formList.lastName"
              placeholder="Last Name"
            ></LineInput>
          </a-form-item>
        </a-col>
      </a-row>

      <a-form-item name="email">
        <LineInput
          class="input-item"
          v-model:value="formList.email"
          placeholder="Email"
        ></LineInput>
      </a-form-item>

      <a-form-item name="phone">
        <LineInput
          class="input-item"
          v-model:value="formList.phone"
          placeholder="Phone Number"
        ></LineInput>
      </a-form-item>

      <a-form-item name="sex">
        <div class="radio-button-group">
          <div
            :class="{
              'radio-button': true,
              'radio-button-active': radioButtonActive[index],
              'radio-button-unactive': !radioButtonActive[index],
            }"
            v-for="(item, index) in genderList"
            :key="item.value"
            @click="genderChange(item.value, index)"
          >
            {{ item.label }}
          </div>
        </div>
      </a-form-item>

      <a-form-item name="routeType">
        <LineSelect
          v-model:value="formList.routeType"
          :selectList="routeTypeList"
          placeholder="How you know us?"
        ></LineSelect>
      </a-form-item>

      <div class="button" @click="handleRegister">
        Submit
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import LineInput from '@/components/LineInput'
import LineSelect from '@/components/LineSelect'
import { signUp } from '@/api/base'
import { validateEmail, validatePhone } from '@/utils/validate'

export default {
  name: 'ContactSalesModal',
  components: { LineInput, LineSelect },
  data() {
    let validateMail = async (rule, value) => {
      if (!value) {
        return Promise.reject('Login email is required')
      } else if (!validateEmail(value)) {
        return Promise.reject('Please enter the correct email format')
      } else {
        return Promise.resolve()
      }
    }
    let validateGender = async (rule, value) => {
      if (!value) {
        return Promise.reject('Please select gender')
      } else {
        return Promise.resolve()
      }
    }
    let validatePhoneNumber = async (rule, value) => {
      if (!value) {
        return Promise.reject('Phone number is required')
      } else if (!validatePhone(value)) {
        return Promise.reject('Please enter the correct phone format')
      } else {
        return Promise.resolve()
      }
    }
    return {
      modalVisible: this.$route.params.path === '/' ? true : false,
      account: '',
      formList: {
        email: undefined,
        phone: undefined,
        sex: undefined,
        firstName: undefined,
        lastName: undefined,
        routeType: undefined,
        country: undefined,
      },
      rules: {
        country: [
          {
            required: true,
            message: 'Please select country',
            trigger: 'change',
          },
        ],
        firstName: [
          {
            required: true,
            message: 'First name is required',
            trigger: 'blur',
          },
        ],
        lastName: [
          {
            required: true,
            message: 'Last name is required',
            trigger: 'blur',
          },
        ],
        email: [{ validator: validateMail, trigger: 'blur' }],
        phone: [
          {
            validator: validatePhoneNumber,
            trigger: 'blur',
          },
        ],
        sex: [{ validator: validateGender, trigger: 'change' }],
        routeType: [
          {
            required: true,
            message: 'Please select the way you know us',
            trigger: 'blur',
          },
        ],
      },
      genderList: [
        {
          label: 'Female',
          value: 'female',
        },
        {
          label: 'Male',
          value: 'male',
        },
        {
          label: 'Keep secret',
          value: 'secret',
        },
      ],
      routeTypeList: [
        {
          label: 'referral',
          value: 'referral',
        },
        {
          label: 'Ads',
          value: 'Ads',
        },
        {
          label: 'Existing client',
          value: 'Existing client',
        },
        {
          label: 'Offline seminar',
          value: 'Offline seminar',
        },
        {
          label: 'Others',
          value: 'Others',
        },
      ],
      radioButtonActive: [],
    }
  },
  created() {},
  computed: {
    countriesList() {
      return this.$store.state.base.allCountriesList
    },
  },
  methods: {
    showModal() {
      this.$store.dispatch('base/GetCountriesList')
      this.modalVisible = true
    },
    genderChange(val, index) {
      this.formList.sex = val
      this.radioButtonActive = Array(3).fill(false)
      this.radioButtonActive[index] = true
    },
    handleRegister() {
      this.$refs.formList.validate().then(() => {
        this.formList.areaCode = this.countriesList.find((item) => {
          return item.nameEn === this.formList.country
        }).areaCode
        signUp(this.formList).then(() => {
          this.handleCloseModal()
          this.$message.success('Thank you! Now please check your emailbox.')
        })
      })
    },
    handleCloseModal() {
      this.modalVisible = false
      this.formList = {
        email: '',
        phone: '',
        sex: '',
        firstName: '',
        lastName: '',
        routeType: undefined,
        country: undefined,
      }
      this.radioButtonActive = Array(3).fill(false)
    },
    filterOption(input, option) {
      return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  },
}
</script>

<style lang="scss" scoped>
.hint {
  color: #333;
  font-size: 16px;
}
</style>

<style lang="scss">
.radio-button-group {
  width: 100%;
  display: flex !important;
  justify-content: space-between;
  user-select: none;

  .radio-button {
    text-align: center;
    width: 30%;
    height: 40px;
    line-height: 40px;
    border: none;
    background-color: #ebebeb;
    border: #ebebeb solid 1px;
    border-radius: 4px;
    color: #c1c1c1;
    cursor: pointer;
    transition-duration: 0.3s;
  }
  .radio-button-unactive {
    &:hover {
      color: $mainColor;
      border-color: $mainColor;
      // background-image: linear-gradient(to left, #00b0ff, #007dff);
    }
  }
  .radio-button-active {
    color: #fff;
    background-image: linear-gradient(to left, #00b0ff, #007dff);
  }
}
</style>
